var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.00002 0.166626C1.43521 0.166626 0.166687 1.43515 0.166687 2.99996C0.166687 4.56477 1.43521 5.83329 3.00002 5.83329C4.47257 5.83329 5.68257 4.71007 5.8203 3.27354C5.82671 3.20668 5.79237 3.14251 5.73318 3.11076C5.67399 3.07901 5.60153 3.08589 5.54938 3.12821C5.26282 3.36074 4.89791 3.49996 4.50002 3.49996C3.57955 3.49996 2.83335 2.75377 2.83335 1.83329C2.83335 1.28659 3.0964 0.801371 3.50355 0.497181C3.55738 0.456961 3.58179 0.388347 3.56547 0.323163C3.54914 0.25798 3.49526 0.208978 3.42882 0.198887C3.28889 0.177633 3.14569 0.166626 3.00002 0.166626Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMoon);
export default __webpack_public_path__ + "static/media/ico-moon.fdb82c59af0353dc6103dcd95366c9e3.svg";
export { ForwardRef as ReactComponent };